import Vue from 'vue'
const RESOURCE = 'clipboard'

async function crudTemplate(_, { data, callback }) {
  try {
    const { method = 'get' } = this
    const url = data.clipboardId ? `${RESOURCE}/${data.clipboardId}` : RESOURCE
    const res = await Vue.request[method](url, data)
    if (res.status !== 200) throw new Error('Error copying to clipboard')
    callback(res.data)
  } catch (e) {
    console.error(e)
    const error = { error: e.message }
    callback && callback(error)
  }
}

const state = {
  clipboard: null,
  clipboardData: null,
  clipboardType: null
}

const actions = {
  copy: crudTemplate.bind({ method: 'post' }),
  paste: crudTemplate.bind({ method: 'post' }),
  delete: crudTemplate.bind({ method: 'delete' }),
  get: crudTemplate.bind({ method: 'get' })
}

const mutations = {
  setClipboard(state, payload) {
    state.clipboard = payload
  },
  setClipboardData(state, payload) {
    state.clipboardData = payload
  },
  resetClipboard(state) {
    state.clipboard = null
    state.clipboardData = null
    state.clipboardType = null
  },
  setClipboardType(state, payload) {
    state.clipboardType = payload
  }
}

const getters = {
  clipboard: (state) => state.clipboard,
  clipboardData: (state) => state.clipboardData,
  clipboardType: (state) => state.clipboardType
}

export default {
  actions,
  state,
  mutations,
  getters
}
